export let test_name = [];
test_name[1] = "Диагностика Луны";
test_name[2] = "Диагностика Солнца";
test_name[3] = "Диагностика Сатурна";
test_name[4] = "Диагностика Венеры";
test_name[5] = "Диагностика Меркурия";
test_name[6] = "Диагностика Марса";
test_name[7] = "Диагностика Юпитера";

//---------------------------------------- Луна -----------------------------------------------------
export let question = [];
question[0] = "Часто ли ты находишься в состоянии усталости и апатии?";
question[1] = "Чувствуешь злость или обиду на маму?";
question[2] = "Часто ли споришь с родными, доказывая правоту своего мнения?";
question[3] = "Регулярно ли ты повышаешь голос?";
question[4] = "Часто ли ты находишься в состоянии истерики?";
question[5] = "Ты находишься во власти вредных привычек?";
question[6] = "Часто ли тебя одолевает жгучая ревность?";
question[7] = "Сложно ли тебе засыпать?";
question[8] = "Сильно ли ты привязываешься к людям или предметам?";
question[9] = "Знакома ли ты с депрессией?";
question[10] = "Ощущаешь ли неловкость, когда получаешь заботу или слышишь комплименты?";
question[11] = "Правильно ли ты питаешься, имеются ли проблемы с весом?";
question[12] = "Тебе свойственно обижаться по любому поводу?";
question[13] = "Мечтаешь ли ты изменить людей из своего окружения?";
question[14] = "Часто ли тебя посещает желание остаться одной и просто отдохнуть от накопившихся проблем?";
question[15] = "Ставишь ли ты целью своей жизни кого-то или что-то одно (детей, мужа, маму, папу, работу и т.д.)?";
question[16] = "Тебе сложно уловить “голос” своей интуиции?";
question[17] = "Свойственно ли тебе сопереживание?";
question[18] = "Тревожишься ли ты без видимых причин?";
question[19] = "Различные мелочи способы вывести тебя из себя?";

//---------------------------------------- Солнце -----------------------------------------------------
question[20] = "Случается ли такое, что ты не можешь начать дело, потому что боишься неудачи?";
question[21] = "У тебя нет ни одного хобби, которым интересуешься постоянно?";
question[22] = "Не хватает ли тебе стабильности во всём, в том числе, финансах?";
question[23] = "Ты много работаешь, но повышение зарплаты или премии обходят тебя стороной?";
question[24] = "Хочется ли тебе контролировать все сферы своей жизни?";
question[25] = "Тяжело ли тебе принимать решения самостоятельно, из-за чего постоянно советуешься с другими?";
question[26] = "Как считаешь, часто ли ты кажешься пустым местом в глазах других?";
question[27] = "Многие ли считают твоё мнение попросту ненужным?";
question[28] = "Уверена ли ты, что держишь под контролем хотя бы 50% своей жизни?";
question[29] = "Чувствуешь ли себя хомяком в колесе, который не может выбраться из замкнутого круга?";
question[30] = "Часто ли тобой движет страх совершить ошибку?";
question[31] = "У тебя не хватает энергии даже для рутинных задач?";
question[32] = "Часто ли ты отказываешься от своих действий, которые осуждают родные?";
question[33] = "На пути к мечте тебя останавливают страхи?";
question[34] = "Ты стараешься, а начальник всё равно вечно недоволен?";
question[35] = "Тебе сложно просыпаться по утрам?";
question[36] = "Часто ли твои планы остаются нереализованными?";
question[37] = "Считаешь ли ты, что талантов в тебе мало или вовсе нет?";
question[38] = "У тебя совсем нет желания выделиться из толпы?";
question[39] = "Находишься ли ты в непрерывном действии, которое почему-то не приводит к результату?";


//---------------------------------------- Сатурн -----------------------------------------------------
question[40] = "Часто ли думаешь, что тебе не удастся довести начатое дело до конца?";
question[41] = "Часто ли ты позволяешь себе резкие претензии в сторону других людей?";
question[42] = "Часто ли получаешь критику в свой адрес?";
question[43] = "Ты уверена, что не справишься сама без чьей-либо помощи?";
question[44] = "Часто ли ты испытываешь обиду?";
question[45] = "Часто ли ты ощущаешь страх в любом его проявлении?";
question[46] = "Нацелена ли ты на то, чтобы всё вокруг было сделано правильно? Часто ли вообще употребляешь это слово?";
question[47] = "Часто ли ты опаздываешь или боишься не успеть, из-за чего собираешься впопыхах?";
question[48] = "Часто ли ты жадничаешь, не желая делиться эмоциями, знаниями, временем и прочими ценными ресурсами?";
question[49] = "Ты боишься совершать неправильные действия, пусть даже случайно?";
question[50] = "Часто ли ты недовольна своим внешним видом и поведением?";
question[51] = "В непонятной ситуации ты прокручиваешь в голове только плохой или худший вариант исхода событий?";
question[52] = "Хочется ли тебе полноценно контролировать каждый аспект своей жизни?";
question[53] = "Ты считаешь, что раньше было лучше? Речь идёт конкретно о твоей жизни.";
question[54] = "Часто ли ты сама занимаешься необоснованной критикой?";
question[55] = "Тебе кажется, что все норовят тебя обмануть?";
question[56] = "После 29 лет твоя жизнь изменилась в худшую сторону?";
question[57] = "Вокруг тебя больше жестоких, негативных, жадных людей?";
question[58] = "Ты всё время чего-то ждешь – лучшей жизни, помощи, финансовой поддержки, одобрения и т.д.?";
question[59] = "Редко ли ты позволяешь себе проявлять позитивные эмоции?";

//---------------------------------------- Венера -----------------------------------------------------
question[60] = "Часто ли тебе приходится ограничиваешь свои траты?";
question[61] = "У тебя не получается следить за своими доходами и расходами?";
question[62] = "Часто ли ты ощущаешь острую нехватку денег?";
question[63] = "Ты чувствуешь вину, когда направляешь внимание в свою сторону?";
question[64] = "Твои доходы отличаются стабильностью, но не становятся больше.";
question[65] = "Тебе не хватает времени на то, чтобы наслаждаться природой, вкусной пищей, интересными мероприятиями и другими благами?";
question[66] = "Тебе сложно описать свои чувства? Не эмоции, а конкретно ощущения?";
question[67] = "Твои доходы нестабильны или их рост сложно предугадать?";
question[68] = "Часто ли ты винишь себя за лишние траты и дорогостоящие покупки?";
question[69] = "Ты редко слышишь комплименты в свой адрес?";
question[70] = "Часто ли тебе недостает времени для своих интересов?";
question[71] = "Ты редко наряжаешься в красивую одежду и наносишь макияж?";
question[72] = "Дело, которым сейчас занимаешься, не приносит тебе удовольствие?";
question[73] = "Часто ли тебе приходится занимать деньги, потому что траты превышают бюджет?";
question[74] = "Часто тебе не нравится то, что видишь в зеркале?";
question[75] = "Живёшь ли ты в постоянной спешке?";
question[76] = "Ты тратишь меньше 20% времени и денег на личные нужды?";
question[77] = "Тебе сложно приобрести вещь, которая нужна, потому что ты не привыкла тратиться на себя?";
question[78] = "У тебя не складываются отношения с противоположным полом?";
question[79] = "Ты бы хотела, но не получается уделять время и деньги своей внешности?";

//---------------------------------------- Меркурий -----------------------------------------------------
question[80] = "Часто ли ты не слышишь то, что тебе говорят?";
question[81] = "Часто ли ты забываешь о своих намерениях? Например, куда направлялась.";
question[82] = "Часто ли ты хватаешься за несколько дел одновременно?";
question[83] = "Часто ли ты делаешь выводы на основе своего понимания, пусть и неверного?";
question[84] = "Часто ли ты в приоритет ставишь неважные дела, из-за чего не успеваешь реализовать важные?";
question[85] = "Тяжело ли тебе “словить” одну идею среди роя мыслей в голове?";
question[86] = "Часто ли ты ловишь себя на мысли, что не слушаешь собеседника?";
question[87] = "Сложно ли тебе читать длинные тексты?";
question[88] = "Часто ли ты уходишь в себя, зарываешься в собственных мыслях?";
question[89] = "Тебя редко посещают полезные идеи, озарение, вдохновение?";
question[90] = "Ты не любишь выполнять монотонную работу?";
question[91] = "Сложно ли тебе решать логические задачи?";
question[92] = "Ты правша?";
question[93] = "Часто ли ты читаешь поверхностно, пытаясь понять контекст без углубления в тему?";
question[94] = "Ты не умеешь презентабельно рассказывать о себе и своём продукте?";
question[95] = "Боишься ли ты задать уточняющие вопросы, боясь показаться глупой?";
question[96] = "Часто ли ты становишься жертвой обмана или мошенничества?";
question[97] = "Часто ли ты лжешь или оформляешь факты так, как тебе удобно? Будь честна перед собой.";
question[98] = "Тебе сложно даются продажи?";
question[99] = "Часто ли ты не обращаешь внимания на повседневные детали?";

//---------------------------------------- Марс -----------------------------------------------------
question[100] = "Нуждаешься ли ты в дружеской поддержке, чтобы сделать первый шаг в реализации желаемого?";
question[101] = "Часто ли ты переходишь на крик?";
question[102] = "Ты занимаешься спортом, но тренировки проходят редко?";
question[103] = "Часто ли ты занимаешься чем-либо бесцельно?";
question[104] = "Часто ли ты сожалеешь о поступках, которые так и не совершила?";
question[105] = "Часто ли хочется физически навредить кому-то, избить?";
question[106] = "В сексе ты выбираешь пассивные позиции?";
question[107] = "Часто ли ты ощущаешь упадок сил?";
question[108] = "Сложно ли тебе приступать к действиям?";
question[109] = "Часто ли ты испытываешь головные боли?";
question[110] = "Случается ли так, что тебе приходится соперничать с мужчинами?";
question[111] = "Часто ли ты испытываешь приступы ревности?";
question[112] = "Часто ли тебе приходится переходить на грубости в разговорах с родными?";
question[113] = "Ты редко проявляешь инициативу? Часто ли ждёшь, пока тебе сделают ценное предложение?";
question[114] = "Часто ли тебе хочется что-то уничтожить? Например, разбить стакан или порвать свои записи.";
question[115] = "У тебя обнаружены заболевания желудка?";
question[116] = "Часто ли ты ощущаешь дискомфорт в мышцах?";
question[117] = "Часто ли ты скандалишь?";
question[118] = "Часто ли ты сжимаешь челюсти? Проанализируй себя, прежде чем дать ответ.";
question[119] = "Часто ли тебя одолевает лень?";
//---------------------------------------- Юпитер -----------------------------------------------------
question[120] = "Уверена ли ты, что не сможешь достичь значимых целей?";
question[121] = "Часто ли ты под гнетом рутинных задач вынуждена отложить на потом главную задачу?";
question[122] = "Сложно ли тебе вынести за скобки главную мысль в длинном тексте?";
question[123] = " Посещает ли тебя ощущение того, что находишься в другой реальности, а твоя жизнь проплывает мимо?";
question[124] = "У тебя не получается сесть и потратить много времени на написание чего-либо?";
question[125] = "Часто ли ты теряешь нить повествования, когда что-то рассказываешь?";
question[126] = "Часто ли ты теряешь вещи и не можешь сконцентрироваться?";
question[127] = "У тебя имеются проблемы с весом?";
question[128] = "Сложно ли тебе представить своё будущее через 20 лет?";
question[129] = "Часто ли ты отвлекаешься на посторонние мысли во время разговора с собеседником?";
question[130] = "Часто ли ты забываешь свои прошлогодние планы?";
question[131] = "Часто ли ты переносишь выполнение важных задач на неопределённый срок?";
question[132] = "Часто ли ты решаешь просто ничего не делать?";
question[133] = "Сложно ли тебе взяться за масштабное дело без длительной подготовки?";
question[134] = "Часто ли Фортуна обходит тебя стороной?";
question[135] = "Часто ли ты забываешь важные даты? Нужно ли регулярно записывать напоминания?";
question[136] = "Тебя огорчает твоя память, в которой тяжело что-то сохранить?";
question[137] = "Редко ли ты ставишь себе цели? Хотя бы те, которые помогут закрыть все основные потребности.";
question[138] = "Сложно ли тебе воспринимать большие объемы информации?";
question[139] = "Сложно ли тебе абстрагироваться от серьёзной проблемы и посмотреть на неё с точки зрения рациональности, без эмоций?";